import { render, staticRenderFns } from "./skill.vue?vue&type=template&id=83b42180&scoped=true"
import script from "./skill.vue?vue&type=script&lang=js"
export * from "./skill.vue?vue&type=script&lang=js"
import style0 from "./skill.vue?vue&type=style&index=0&id=83b42180&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83b42180",
  null
  
)

export default component.exports